import Menu from 'Models/Menu';

export default [
  // Menu.assetInformation,
  Menu.assetEdit,
  Menu.assetDelete,
  Menu.searchAsset,
  // Menu.assetClone,
  // Menu.assetAlert,
  Menu.assetsHelp,
];
